/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Category_FixInputs */

const vi_whats_new_category_fix = /** @type {(inputs: Whats_New_Category_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa lỗi`)
};

/**

* @param {Whats_New_Category_FixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_category_fix = /** @type {((inputs?: Whats_New_Category_FixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Category_FixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_category_fix(inputs)
});